import { Send } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const Container = styled.div`
  height: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 7%;
`;

const Title = styled.h1`
  font-size: 70px;
  margin-bottom: 20px;

  @media only screen and (max-width: 760px) {
    font-size: 25px;
    margin-bottom: 10px;
  }
`;
const Description = styled.p`
  font-size: 24px;
  font-weight: 300;
  margin-bottom: 20px;
  @media only screen and (max-width: 760px) {
    margin-bottom: 10px;
    font-size: 17px;
  }
`;
const InputContainer = styled.div`
  width: 50%;
  height: 40px;
  min-width: 320px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-bottom: 7%;
`;
const Input = styled.input`
  border: none;
  flex: 8;
  padding-left: 20px;
  border-radius: 5px;
`;
const SendButton = styled.button`
  flex: 1;
  border: none;
  background-color: teal;
  cursor: pointer;
  color: white;
  border-radius: 5px;
`;

const Newsletter = () => {
  const notify = () => toast("You email has been registered!");

  return (
    <>
      <Container>
        <Title>Newsletter</Title>
        <Description>
          Sign up for our newsletter to stay updated on new arrivals and
          exclusive deals!
        </Description>
        <InputContainer>
          <Input placeholder="Your email" />
          <SendButton onClick={notify}>
            <Send />
          </SendButton>
        </InputContainer>
      </Container>
      <ToastContainer />
    </>
  );
};

export default Newsletter;
